<template>
  <Transition name="tips-fade">
    <p v-if="currentTip" class="px-4 text-xs italic text-light-fg-muted">
      {{ currentTip }}
    </p>
  </Transition>
</template>

<script setup lang="ts">
import { CHAT_TIPS, CHAT_TIPS_DELAY_MS, CHAT_TIPS_INTERVAL_MS } from '@/wabunka-src/features/Chat/models/chatTips';

interface Props {
  active: boolean;
}

const props = defineProps<Props>();

const currentIndex = ref(-1);
const currentTip = computed(() => (currentIndex.value >= 0 ? CHAT_TIPS[currentIndex.value % CHAT_TIPS.length] : null));

let delayTimer: ReturnType<typeof setTimeout> | undefined;
let intervalTimer: ReturnType<typeof setInterval> | undefined;

const stopRotation = () => {
  if (delayTimer) clearTimeout(delayTimer);
  if (intervalTimer) clearInterval(intervalTimer);
  delayTimer = undefined;
  intervalTimer = undefined;
  currentIndex.value = -1;
};

const startRotation = () => {
  stopRotation();
  currentIndex.value = -1;

  delayTimer = setTimeout(() => {
    currentIndex.value = 0;
    intervalTimer = setInterval(() => {
      currentIndex.value = (currentIndex.value + 1) % CHAT_TIPS.length;
    }, CHAT_TIPS_INTERVAL_MS);
  }, CHAT_TIPS_DELAY_MS);
};

watch(
  () => props.active,
  (active) => {
    if (active) {
      startRotation();
    } else {
      stopRotation();
    }
  },
  { immediate: true },
);

onUnmounted(() => stopRotation());
</script>

<style lang="scss" scoped>
.tips-fade-enter-active,
.tips-fade-leave-active {
  transition: opacity 0.3s ease;
}

.tips-fade-enter-from,
.tips-fade-leave-to {
  opacity: 0;
}
</style>
